import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// var variable = "Test";
//
// <section>
//   <p>{variable}</p>
// </section>
//



class CenteredTextTest extends Component {
  render(){
    var p = this.props;
    return (
      <div style={style.frame}>
        <div style={{width: p.CTObj.width, ...style.parent}}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default CenteredTextTest;

var style = {
  frame: {
    width: '100%',
    height: '100%',
    position: 'relative',
    background: 'white'
  },
  parent: {
    // position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'table',
    width: '70%',
    'margin-right': 'auto',
    'margin-top': '70px'
  },
  title: {
    paddingBottom: '5px'
  },
  text: {
    fontFamily: 'proxima-nova',
    lineHeight: 1.5,
    color: 'rgb(240, 240, 240)',
    textAlign: 'justify',
    width: '70%',
  }
}



const TitleAndButton = (props) => {
    return (<div>
              <div id="centered-text-title" style={{textTransform: 'uppercase', fontFamily: 'proxima-nova', ...style.title}}>{props.CTObj.title}</div>
              <div id="centered-text-body" style={{...style.text}}>{props.CTObj.text}</div>
              <button className="backgroundSectionButton"><Link to={"/floor-plans"}>Explore</Link></button>
            </div>)
}



// WEBPACK FOOTER //
// ./src/CenteredTextTest.js